import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { base_api_url } from "../../../environment.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { QrCode } from "lucide-react";
import "./signin.css";

const MySwal = withReactContent(Swal);

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  // en cas de changement fde valeur d'un element du formulaire sera setFormData lancer pour mettre a jour les donne
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  //pour recuprer les element du formulaire
  const [formData, setFormData] = useState({
    "email": "",
    "mot_de_passe": ""
  });
  const [loading, setLoading] = useState(false);
  const route = all_routes;
  const navigate = useNavigate();

  // pour la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault(); // éviter le rechargement de la page
    setLoading(true);
    try {
      const response = await axios.post(`${base_api_url}api/login`, formData);

      console.log("Réponse API :", response.data);

      // Save user data first
      localStorage.setItem("user", JSON.stringify(response.data));

      // If cuisinier (role 4), store as cuisinier_actif and redirect to cuisine
      if (response.data.role === 4) {
        localStorage.setItem("cuisinier_actif", JSON.stringify(response.data));
        MySwal.fire({
          icon: "success",
          text: `Bienvenue cuisinier ${response.data.nom_cuisinier || response.data.nom || ""}`,
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: { popup: "pixel-toast" },
        });
        setTimeout(() => {
          navigate("/cuisine?id_restaurant=" + (response.data.id_restaurant || response.data.restaurant_id || ""));
        }, 1000);
        return;
      }

      // Otherwise, normal flow
      await checkAndHandleRestaurants(response.data.access_token);

    } catch (error) {
      // Show error toast with reduced height
      let errorMessage = "Veuillez réessayer.";
      if (error.response) {
        const status = error.response.status;
        if (status === 401 || status === 404 || status === 400) {
          errorMessage = "Email ou mot de passe incorrect.";
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        }
      } else if (error.request) {
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion.";
      }

      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const checkAndHandleRestaurants = async (token) => {
    try {
      // Récupérer les informations utilisateur depuis le localStorage
      const userStr = localStorage.getItem("user");
      const userData = userStr ? JSON.parse(userStr) : {};

      // Vérifier si l'utilisateur a déjà un restaurant assigné (employé)
      if (userData.id_restaurant && userData.id_restaurant !== null) {
        console.log("Utilisateur avec restaurant assigné détecté:", userData.id_restaurant);

        try {
          // Récupérer les détails du restaurant assigné
          const restaurantResponse = await axios.get(`${base_api_url}api/restaurant/${userData.id_restaurant}`, {
            headers: { Authorization: `Bearer ${token}` }
          });

          console.log("Restaurant assigné récupéré:", restaurantResponse.data);

          // Mettre à jour les données utilisateur avec les infos du restaurant
          const updatedUser = {
            ...userData,
            restoId: userData.id_restaurant,
            restoNom: restaurantResponse.data.restaurant?.nom || restaurantResponse.data.Restaurant?.nom
          };
          localStorage.setItem("user", JSON.stringify(updatedUser));

          // Sauvegarder les détails du restaurant
          localStorage.setItem("restaurant", JSON.stringify(restaurantResponse.data));

          // Afficher un message de succès spécifique aux employés
          const restaurantName = restaurantResponse.data.restaurant?.nom || restaurantResponse.data.Restaurant?.nom;
          const userRole = userData.role == 3 ? "Serveur" : userData.role == 2 ? "Gestionnaire" : "Employé";

          MySwal.fire({
            icon: "success",
            // title: "Connexion réussie !",
            text: `Bienvenue ${userRole} du restaurant "${restaurantName}".`,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });

          setTimeout(() => {
            // Rediriger vers le tableau de bord ou la page appropriée selon le rôle
            if (userData.role && userData.role === 3) {
              navigate(route.commands);
            } else {
              navigate(route.articlesNew);
            }
          }, 2000);

          return; // Sortir de la fonction car le traitement est terminé

        } catch (restaurantError) {
          console.error("Erreur lors de la récupération du restaurant assigné:", restaurantError);

          //           let errorTitle = "Erreur de restaurant assigné";
          let errorMessage = "Impossible de récupérer les informations de votre restaurant.";

          if (restaurantError.response) {
            const status = restaurantError.response.status;
            const errorData = restaurantError.response.data;

            switch (status) {
              case 401:
                //                 errorTitle = "Session expirée";
                errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
                break;

              case 403:
                //                 errorTitle = "Accès refusé";
                errorMessage = "Vous n'avez pas l'autorisation d'accéder à ce restaurant.";
                break;

              case 404:
                //                 errorTitle = "Restaurant introuvable";
                errorMessage = "Le restaurant qui vous est assigné n'existe plus ou a été supprimé. Contactez votre administrateur.";
                break;

              case 500:
                //                 errorTitle = "Erreur du serveur";
                errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
                break;

              default:
                //                 errorTitle = `Erreur ${status}`;
                errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors de la récupération du restaurant.";
            }
          } else if (restaurantError.request) {
            //             errorTitle = "Problème de connexion";
            errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
          }

          MySwal.fire({
            icon: "error",
            // title: errorTitle,
            text: errorMessage,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });

          // En cas d'erreur, déconnecter l'utilisateur
          localStorage.removeItem("user");
          localStorage.removeItem("restaurant");
          return;
        }
      }

      // Connexion d'un proprio
      const response = await axios.get(`${base_api_url}api/restaurant`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const restaurants = response.data.restaurant || [];

      if (restaurants.length === 0) {
        // No restaurants - redirect to restaurants page with message
        MySwal.fire({
          icon: "info",
          // title: "Bienvenue !",
          text: "Commencez par créer votre premier restaurant pour utiliser l'application.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        setTimeout(() => {
          navigate(route.Restaurants);
        }, 2000);

      } else if (restaurants.length === 1) {
        // Auto-select the only restaurant
        const restaurant = restaurants[0];

        // Update user data with restaurant info
        const userStr = localStorage.getItem("user");
        let user = userStr ? JSON.parse(userStr) : {};
        user.restoId = restaurant.id_restaurant;
        user.restoNom = restaurant.nom;
        localStorage.setItem("user", JSON.stringify(user));

        // Get restaurant details and save
        const restoDetails = await axios.get(`${base_api_url}api/restaurant/${restaurant.id_restaurant}`);
        localStorage.setItem("restaurant", JSON.stringify(restoDetails.data));

        MySwal.fire({
          icon: "success",
          // title: "Connexion réussie !",
          text: `Restaurant "${restaurant.nom}" sélectionné automatiquement.`,
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        setTimeout(() => {
          navigate(route.articlesNew);
        }, 2000);

      } else {
        // Multiple restaurants - show selection modal
        MySwal.fire({
          icon: "success",
          // title: "Connexion réussie !",
          text: "Sélectionnez le restaurant à administrer.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        setTimeout(() => {
          navigate(route.Restaurants + "?select=true");
        }, 2000);
      }

    } catch (error) {
      console.error("Error checking restaurants:", error);
      // Fallback to restaurants page
      setTimeout(() => {
        navigate(route.Restaurants);
      }, 2000);
    }
  };

  return (
    <div className="signin-modern-container">
      {/* Section Gauche : Branding (Hidden on mobile) */}
      <div className="signin-left-section">
        {/* Effet de blur orange */}
        <div className="signin-blur-effect"></div>

        {/* Logo et titre */}
        <div className="signin-left-content">
          <div className="signin-logo-wrapper" onClick={() => navigate('/')}>
            <div className="signin-logo-icon">
              <QrCode />
            </div>
            <span className="signin-logo-text">
              QR<span className="signin-logo-text-accent">NYAMA</span>
            </span>
          </div>
          <h2 className="signin-main-title">
            Ravi de vous <br />
            <span className="signin-title-accent">revoir.</span>
          </h2>
        </div>

        {/* Copyright */}
        <p className="signin-copyright">
          © 2026 QRNYAMA. Tous droits réservés.
        </p>
      </div>

      {/* Section Droite : Formulaire */}
      <div className="signin-right-section">
        <div className="signin-form-container">
          {/* Logo mobile (visible uniquement sur mobile) */}
          <div className="signin-mobile-logo">
            <div className="signin-mobile-logo-content">
              <div className="signin-mobile-logo-icon">
                <QrCode />
              </div>
              <span className="signin-mobile-logo-text">
                QR<span className="signin-logo-text-accent">NYAMA</span>
              </span>
            </div>
          </div>

          {/* Header */}
          <div className="signin-header">
            <h3 className="signin-header-title">
              Espace Client
            </h3>
            <p className="signin-header-subtitle">
              Identifiez-vous pour accéder au pilotage.
            </p>
          </div>

          {/* Formulaire */}
          <form onSubmit={handleSubmit} className="signin-form">
            {/* Email */}
            <div className="signin-form-group">
              <label className="signin-label">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="nom@restaurant.com"
                className="signin-input"
              />
            </div>

            {/* Mot de passe */}
            <div className="signin-form-group">
              <label className="signin-label">
                Mot de passe
              </label>
              <div className="signin-password-wrapper">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  name="mot_de_passe"
                  value={formData.mot_de_passe}
                  onChange={handleChange}
                  required
                  placeholder="••••••••"
                  className="signin-input"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="signin-password-toggle"
                >
                  <i className={`fas ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"}`}></i>
                </button>
              </div>
            </div>

            {/* Mot de passe oublié */}
            <div className="signin-forgot-wrapper">
              <Link to={route.forgotPassword} className="signin-forgot-link">
                Mot de passe oublié ?
              </Link>
            </div>

            {/* Bouton de connexion */}
            <button
              type="submit"
              disabled={loading}
              className="signin-submit-btn"
            >
              {loading ? "Connexion en cours..." : "Se connecter"}
            </button>
          </form>

          {/* Lien vers inscription */}
          <p className="signin-footer-text">
            Pas encore de compte ?{" "}
            <Link to={route.register} className="signin-footer-link">
              S&apos;inscrire gratuitement
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};


export default Signin;
